var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-input',_vm._b({attrs:{"type":"datetime-local","step":"any"},model:{value:(_vm.internal),callback:function ($$v) {_vm.internal=$$v},expression:"internal"}},'b-form-input',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }